import React, { useState } from "react";

const MithaContactSection = () => {
  const [hover, setHover] = useState(false);

  return (
    <section
      style={{
        background: "linear-gradient(135deg, #fff7f0, #ffffff)",
        padding: "70px 20px",
        fontFamily: "'Arial','Helvetica',sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "auto",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "40px",
          alignItems: "center",
        }}
      >
        {/* LEFT CONTENT */}
        <div
          style={{
            background: "#ffffff",
            padding: "45px",
            borderRadius: "16px",
            boxShadow: "0 15px 40px rgba(0,0,0,0.08)",
          }}
        >
          <h2
            style={{
              fontSize: "16px",
              fontWeight: 800,
              marginBottom: "15px",
              textTransform: "uppercase",
              color: "#222",
            }}
          >
            Mitha Construction & Development
          </h2>

          <p
            style={{
              fontSize: "15px",
              lineHeight: "1.7",
              color: "#555",
              marginBottom: "18px",
            }}
          >
            C-87, 1st Floor, Sasthri Road,
            <br />
            Thillai Nagar, Trichy – 620018
          </p>

          <p
            style={{
              fontSize: "15px",
              lineHeight: "1.8",
              color: "#333",
              marginBottom: "14px",
            }}
          >
            📞 094431 54732
          </p>

          <p
            style={{
              fontSize: "15px",
              color: "#444",
              marginBottom: "22px",
            }}
          >
            ✉️ mithahomessales@gmail.com
          </p>

          <a
            href="https://maps.app.goo.gl/kGELj7XwWntRpEzN7"
            target="_blank"
            rel="noreferrer"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              background: hover ? "#e56d00" : "#ff7a00",
              color: "#fff",
              padding: "12px 22px",
              borderRadius: "30px",
              fontWeight: 700,
              fontSize: "14px",
              textDecoration: "none",
              transform: hover ? "translateY(-2px)" : "none",
              transition: "all 0.3s ease",
            }}
          >
            Get Direction
            <span style={{ fontSize: "18px" }}>→</span>
          </a>
        </div>

        {/* RIGHT MAP */}
        <div
          style={{
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 15px 40px rgba(0,0,0,0.12)",
          }}
        >
     <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.8368523483327!2d78.68718919999999!3d10.823794399999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baaf59d6441be5f%3A0x50518f9d2fac9b05!2sMitha%20Homes!5e0!3m2!1sen!2sin!4v1766474351024!5m2!1sen!2sin"
  title="Mitha Location"
  loading="lazy"
  allowFullScreen
  referrerPolicy="no-referrer-when-downgrade"
  style={{
    width: "100%",
    height: "420px",
    border: "0",
  }}
/>

        </div>
      </div>

      {/* RESPONSIVE (INLINE MEDIA STYLE HACK) */}
      <style>
        {`
          @media (max-width: 900px) {
            section > div {
              grid-template-columns: 1fr !important;
              text-align: center;
            }
          }
        `}
      </style>
    </section>
  );
};

export default MithaContactSection;
